import React from "react";

import AddIcon from "../../assets/Add-icon-gold.svg";

import CasePageSpeciality from "./CasePageSpecialities";
import "./CasePageFilters.css";

const CasePageSpecialtyFilters = ({
  specialitiesList,
  activeSpecialty,
  onSpecialtyChange,
  specialitiesContainerRef,
  specialityWidth,
  onAddProvider,
}) => {
  const activeIndex =
    activeSpecialty === "all" ? -1 : specialitiesList.findIndex((s) => s.id === activeSpecialty);

  return (
    <div className="case-provider-tabs">
      <div className="case-provider-specialty-tabs" ref={specialitiesContainerRef}>
        <span
          className={`d-flex TreatmentPage-all-trapezium align-items-center justify-content-center ${activeSpecialty === "all" ? "active" : ""}`}
          onClick={() => onSpecialtyChange("all")}
          style={{
            cursor: "pointer",
            color: "white",
            fontWeight: "700",
            fontSize: "14px",
            backgroundColor: activeSpecialty === "all" ? "var(--primary)" : "var(--primary-60)",
            height: "25px",
            paddingLeft: "10px",
            paddingRight: "15px",
            //   width: "34px",
            zIndex: 2,
            marginRight: "0px",
            width: "50px",
          }}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === "Enter" && onSpecialtyChange("all")}
          aria-pressed={activeSpecialty === "all"}
        >
          All
        </span>

        {specialitiesList.map((specialitie, index) => {
          const isActive = activeSpecialty === specialitie.id;
          const isPreviousActive = index === activeIndex - 1;

          return (
            <CasePageSpeciality
              key={specialitie.id}
              specialitie={specialitie}
              onSpecialtyChange={onSpecialtyChange}
              isActive={isActive}
              isPreviousActive={isPreviousActive}
              specialityWidth={specialityWidth}
              isLast={index === specialitiesList.length - 1}
              isFirst={index === 0}
            />
          );
        })}
      </div>
      {onAddProvider && (
        <button
          type="button"
          className="case-provider-add-tab"
          onClick={onAddProvider}
          aria-label="Add Provider"
        >
          <img src={AddIcon} width="15" height="15" alt="" aria-hidden="true" />
          Provider
        </button>
      )}
    </div>
  );
};

export default React.memo(CasePageSpecialtyFilters);
